import {CHANNEL_CONTENT, HOST, PRODUCTION_CONTENT, PAGE_CONTENT, LOAD_BUTTON_TEXT} from "../types";
import i18n from "i18next";

export const getChannelContent = (typeContent) => {
    return dispatch => {
        try {
            return fetch(`${HOST}/v1/${typeContent}`)
                .then((res)=>{
                    return res.json();
                })
                .then(
                    (data) => {
                        if(typeContent==="channels"){
                            dispatch({
                                type: CHANNEL_CONTENT,
                                payload: data
                            })
                        }
                       if(typeContent==="productions"){
                           dispatch({
                               type: PRODUCTION_CONTENT,
                               payload: data
                           })
                       }
                        return data
                })
        } catch (error){

        }
    }
}

export const getPageContent = (page) => {
    return dispatch => {
        try {
            return fetch(`${HOST}/v1/pages/${page}`)
                .then((res)=>{
                    return res.json();
                })
                .then(
                    (data) => {
                        dispatch({
                            type: PAGE_CONTENT,
                            payload: data
                        })
                        return data
                    })
        } catch (error){

        }
    }
}

/**
 * Отдельный запрос текста кнопки скачивания каталога.
 * Он лежит в контенте страницы main, но нужен во всём приложении (Header, Footer, Home),
 * поэтому храним его отдельным полем и не завязываем на pageContent.
 */
export const getLoadButtonText = () => {
    return dispatch => {
        try {
            return fetch(`${HOST}/v1/pages/main`)
                .then((res)=>{
                    return res.json();
                })
                .then(
                    (data) => {
                        dispatch({
                            type: LOAD_BUTTON_TEXT,
                            payload: data?.data?.content?.main?.loadButtonText || ''
                        })
                        return data
                    })
        } catch (error){

        }
    }
}
